module.exports = __webpack_public_path__ + "static/pic02-df55ce80a9041d495e668ed87bb8f81b.jpg";